module.exports = __webpack_public_path__ + "img/water.a087a87c.png";